// styled components
import { createGlobalStyle } from "styled-components";
import styled from "styled-components";

export const GlobalStyles = createGlobalStyle`

  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: all 0.50s linear;
    box-sizing:border-box;
    direction:rtl;
    .nav-tabs{
      
    }
    .form-group{
      input{
          background-color: ${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
          &:focus{
            box-shadow: none
          }
        }
        textarea{
          background-color: ${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
          &:focus{
            box-shadow: none
          }
        }
    }
    .input-picker{
          input{
            background-color: ${({ theme }) => theme.body} !important;
            color: ${({ theme }) => theme.text} !important;
          }
          
        }
        .calender-modal {
            background-color: ${({ theme }) => theme.body} !important;

          ul{
            background-color: ${({ theme }) => theme.body} !important;
          }
          
          li{
            color: ${({ theme }) => theme.text} !important;
          }
          li.is-disabled{
            color: ${({ theme }) => theme.text};
            background-color: ${({ theme }) => theme.box};
          }
        }
        .css-1s2u09g-control{
          background-color: ${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
        }
        .css-1pahdxg-control{
          background-color:${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};

        }
        .css-26l3qy-menu{
          background-color:${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
          &:hover *{
            background-color:${({ theme }) => theme.box};
            color: ${({ theme }) => theme.text};

          }
        }
        .css-qc6sy-singleValue{
          background-color:${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
        }
        .css-6g8wv5-input{
          

        }
        .css-12jo7m5{
          background-color:${({ theme }) => theme.box};
          color: ${({ theme }) => theme.text};
        }
        .css-xb97g8{
          background-color:${({ theme }) => theme.box};
          color: ${({ theme }) => theme.text};
        }
        .css-1rhbuit-multiValue{
          background-color:${({ theme }) => theme.box};
          color: ${({ theme }) => theme.text};
        }
    .custom-class{
      .modal-content{
        background-color: ${({ theme }) => theme.box};
        button{

        }
        .modal-header{
          button{
          background-color: ${({ theme }) => theme.box};
          color: ${({ theme }) => theme.text};
          }
        }
        input{
          background-color: ${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
          &:focus{
            box-shadow: none
          }
        }
        textarea{
          background-color: ${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
          &:focus{
            box-shadow: none
          }
        }
        .input-picker{
          input{
            background-color: ${({ theme }) => theme.body} !important;
            color: ${({ theme }) => theme.text} !important;
          }
          
        }
        .calender-modal {
            background-color: ${({ theme }) => theme.body} !important;

          ul{
            background-color: ${({ theme }) => theme.body} !important;
          }
          
          li{
            color: ${({ theme }) => theme.text} !important;
          }
          li.is-disabled{
            color: ${({ theme }) => theme.text};
            background-color: ${({ theme }) => theme.box};
          }
        }
        .css-1s2u09g-control{
          background-color: ${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
        }
        .css-1pahdxg-control{
          background-color:${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};

        }
        .css-26l3qy-menu{
          background-color:${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
          &:hover *{
            background-color:${({ theme }) => theme.box};
            color: ${({ theme }) => theme.text};

          }
        }
        .css-qc6sy-singleValue{
          background-color:${({ theme }) => theme.body};
          color: ${({ theme }) => theme.text};
        }
        .css-6g8wv5-input{
          

        }
        .css-12jo7m5{
          background-color:${({ theme }) => theme.box};
          color: ${({ theme }) => theme.text};
        }
        .css-xb97g8{
          background-color:${({ theme }) => theme.box};
          color: ${({ theme }) => theme.text};
        }
        .css-1rhbuit-multiValue{
          background-color:${({ theme }) => theme.box};
          color: ${({ theme }) => theme.text};
        }

        /* .e-toolbar-items{
          z-index: 100 !important;
        } */

      }
    }
  }
  
  .active{
    color:#fff;
    border-bottom:3px solid #009EF7;
    a {
    background-color:${({ theme }) => theme.backgroundActive};
    border-radius:3px;
    }

    svg{
      color:${({ theme }) => theme.text};
    }

    p{
      color:${({ theme }) => theme.text};
    }
 
  }

.active1{
  a{

    border-right:2px solid #009EF7;
    background-color:${({ theme }) => theme.backgroundActive};
    width:100%;
    text-align:right;
    display:flex;
    justify-content:flex-start;
    border-top-left-radius:3px;
    border-bottom-left-radius:3px;
  }
}

  /* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px gray; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: gray; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: gray; 
}

  p{
    margin:0px;
    font-family:'IRANSans'
  }

  a{
      text-decoration:none;
      font-family:'IRANSans'
  }

  label{
    font-family:'IRANSans'
  }

  ul{
      list-style:none;
      margin:0;
      padding:0;
  }
  .item-table {
  transition: 0.5s all ease-in;
  cursor: pointer;
}
.item-table:hover {
  background-color: ${({ theme }) => theme.backgroundActive};
}

`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: ${({ between }) => `space-${between}`}; */
  width: ${(props) => (props.sidebar ? props.sidebar : "100%")};
  text-align: right;
  justify-content: flex-start;

  @media (max-width: 576px) {
    .lock {
      display: none;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  /* box-shadow: ${({ theme }) => theme.shadow}; */

  border-radius: 5px;
  td {
    &:hover {
      cursor: pointer;
    }
  }
`;

export const HeaderTitle = styled.h3`
  color: ${({ theme }) => theme.text};
  font-size: 16px;
  font-weight: bold;
  margin: 1rem 0;
`;
